function initToggledFields() {
  const form = document.getElementById("new_client")

  if (!form) {
    return
  }

  const invoiceCheckbox = document.getElementById("client_invoice")
  const addressCheckbox = document.getElementById(
    "client_different_billing_address",
  )
  const termsCheckbox = document.getElementById("client_regulations_accepted")
  const promotionalCheckbox = document.getElementById(
    "client_promotional_contact_accepted",
  )

  const invoiceSections = document.querySelectorAll(".Invoice")
  const addressSections = document.querySelectorAll(".BillingAddress")
  const billingInfo = document.querySelector(".BillingInfo")
  const submitButton = form.querySelector('button[type="submit"]')

  const show = (element) => {
    element.style.display = "block"
  }

  const hide = (element) => {
    element.style.display = "none"
  }

  if (invoiceCheckbox) {
    if (invoiceCheckbox.checked) {
      for (const section of invoiceSections) {
        show(section)
      }
    }

    invoiceCheckbox.addEventListener("change", (e) => {
      for (const section of invoiceSections) {
        invoiceCheckbox.checked ? show(section) : hide(section)
      }

      if (invoiceCheckbox.checked) {
        addressCheckbox.checked = true
        hide(billingInfo)

        for (const section of addressSections) {
          show(section)
        }
      }
    })
  }

  if (addressCheckbox) {
    if (addressCheckbox.checked) {
      hide(billingInfo)

      for (const section of addressSections) {
        show(section)
      }
    }

    addressCheckbox.addEventListener("change", () => {
      addressCheckbox.checked ? hide(billingInfo) : show(billingInfo)

      for (const section of addressSections) {
        addressCheckbox.checked ? show(section) : hide(section)
      }
    })
  }

  if (form.dataset.kind === "review") {
    if (termsCheckbox) {
      submitButton.disabled = !termsCheckbox.checked

      termsCheckbox.addEventListener("change", () => {
        submitButton.disabled = !termsCheckbox.checked
      })
    }
  } else {
    if (termsCheckbox && promotionalCheckbox) {
      submitButton.disabled =
        !termsCheckbox.checked || !promotionalCheckbox.checked

      termsCheckbox.addEventListener("change", () => {
        submitButton.disabled =
          !termsCheckbox.checked || !promotionalCheckbox.checked
      })

      promotionalCheckbox.addEventListener("change", () => {
        submitButton.disabled =
          !termsCheckbox.checked || !promotionalCheckbox.checked
      })
    }
  }

  form.addEventListener("submit", () => {
    submitButton.disabled = true
  })
}

function initValidationCleanup() {
  const form = document.getElementById("new_client")

  if (!form) {
    return
  }

  const elements = form.querySelectorAll("input")

  for (const element of elements) {
    element.addEventListener("change", () => {
      const parent = element.closest(".FormElement--error")

      if (!parent) {
        return
      }

      parent.classList.remove("FormElement--error")

      const error = parent.querySelector(".FormElement__error")
      error.remove()
    })
  }
}

function handleNipData(input) {
  const loaderHandler = input.closest(".loader-handler")
  const token = document.querySelector('[name="csrf-token"]')

  if (!token) {
    return
  }

  const showLoader = () => {
    if (loaderHandler) {
      loaderHandler.classList.add("loading")
    }
  }

  const hideLoader = () => {
    if (loaderHandler) {
      loaderHandler.classList.remove("loading")
    }
  }

  const nip = input.value.replace(/\s|-/g, "")

  if (nip.includes("PL") && nip.length !== 12) {
    return
  }

  if (!nip.includes("PL") && nip.length !== 10) {
    return
  }

  showLoader()

  fetch(input.dataset.url, {
    method: input.dataset.method,
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      nip: nip.replace("PL", ""),
      authenticity_token: token.getAttribute("content"),
    }),
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error()
      }

      return res.json()
    })
    .then((data) => {
      hideLoader()

      if (data["company_name"]) {
        document.getElementById("client_company_name").value =
          data["company_name"]
      }

      if (data["street"]) {
        document.getElementById(
          "client_billing_address_attributes_street",
        ).value = data["street"]
      }

      if (data["postcode"]) {
        document.getElementById(
          "client_billing_address_attributes_postcode",
        ).value = data["postcode"]
      }

      if (data["city"]) {
        document.getElementById(
          "client_billing_address_attributes_city",
        ).value = data["city"]
      }

      if (data["country"]) {
        document.getElementById(
          "client_billing_address_attributes_country",
        ).value = data["country"]
      }
    })
    .catch(() => {
      hideLoader()
    })
}

function initNipData() {
  const form = document.getElementById("new_client")

  if (!form) {
    return
  }

  const vatNumberInput = document.getElementById("client_vat_number")

  if (vatNumberInput) {
    vatNumberInput.addEventListener("change", () => {
      handleNipData(vatNumberInput)
    })
  }
}

window.addEventListener("DOMContentLoaded", () => {
  initToggledFields()
  initValidationCleanup()
  initNipData()
})
